<template>
    <div class="side-panel">
        <div class="side-panel__title">
            <slot name="title"></slot>
        </div>

        <div class="side-panel__content">
            <slot name="content"></slot>
        </div>
    </div>
</template> 

<script>
export default {
    name: 'SidePanel'
}
</script>

<style scoped>
.side-panel {
    width: 100%;
    height: 100%;
    max-height: 100%;
    min-height: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    box-sizing: border-box;
}

.side-panel__title {
    margin-bottom: 20px;
    font-size: 1rem;
    color: rgb(var(--v-theme-secondary));
    flex-shrink: 0;
}

.side-panel__content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}
</style>
